export function getUserDisplayName(userData) {
  const user = userData || {};
  return user.displayName ||
         ((user.firstName && user.surname) ? `${user.firstName} ${user.surname}` : '');
}
